import { Component } from '@angular/core';

@Component({
  selector: 'app-test-dev',
  imports: [],
  templateUrl: './test-dev.component.html',
  styleUrl: './test-dev.component.css'
})
export class TestDevComponent {

}
